import React from 'react';
import { useTranslation } from 'react-i18next';

export default function (props) {
	const { t } = useTranslation(['Core']);
	return (
		<div className="mdl-cell mdl-cell--12-col text-center otherinfo-btn-container">
			<button
				className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
				onClick={props.onBack}
				id="back-btn-otherinfo"
				type="button">
				{t('buttons.back')}
			</button>
			{!props.isContinueHidden ? (
				<button
					
					className="mdl-button mdl-js-button mdl-button--raised mdl-button--colored continue-btn-otherinfo btn-green"
					disabled={props.isDisabled}
					onClick={props.onContinue}
					type="button">
					{(() => {
						return props.continueButtonText ? t(props.continueButtonText) : t('buttons.continue');
					})()}
				</button>
			) : null}
		</div>
	);
}
